import { BookOpen, Award, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import adjusterOnlineCourse from "@/assets/adjuster-online-course.jpg";

export const AdjusterServicesSection = () => {
  const { t } = useTranslation();

  return (
    <section id="adjuster-services" className="py-12 bg-background scroll-mt-20" aria-labelledby="adjuster-services-heading">
      <div className="container mx-auto px-4">
        <h2 id="adjuster-services-heading" className="text-3xl md:text-4xl font-bold text-center border-b border-border pb-4 mb-10">{t('services.adjusterServices')}</h2>

        <div className="max-w-4xl mx-auto space-y-10">
          <div className="py-8 bg-primary text-primary-foreground rounded-lg px-6">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="space-y-4">
                <div>
                  <h3 className="text-2xl font-bold mb-2">{t('services.adjuster.title')}</h3>
                  <p className="text-lg font-semibold mb-1">{t('services.adjuster.subtitle')}</p>
                  <p className="text-base">{t('services.adjuster.credit')}</p>
                </div>
                <div className="space-y-3 text-sm">
                  <p>{t('services.adjuster.p1')}</p>
                  <p>{t('services.adjuster.p2')}</p>
                  <p>{t('services.adjuster.p3')}</p>
                </div>
                <div className="pt-4 border-t border-primary-foreground/20 flex items-center gap-2">
                  <p className="text-base font-semibold">{t('services.adjuster.moreInfo')}</p>
                  <a href="mailto:ce@tpshousing.com" className="text-lg hover:underline">
                    ce@tpshousing.com
                  </a>
                </div>
              </div>
              <div>
                <img src={adjusterOnlineCourse} alt="Insurance adjuster taking online continuing education course" className="rounded-2xl shadow-2xl w-full" />
              </div>
            </div>
          </div>

          <div className="bg-muted rounded-lg p-6">
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-primary" />
              Course Highlights
            </h3>
            <ul className="space-y-3 text-muted-foreground text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>State-approved continuing education credits accepted nationwide</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>Self-paced online format — study on your own schedule</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>Expert-led curriculum covering the latest industry standards</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>Instant certificate of completion upon passing</span>
              </li>
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-muted rounded-lg p-5 text-center">
              <Award className="w-8 h-8 mx-auto mb-3 text-primary" />
              <h4 className="font-bold text-lg mb-1">Certified</h4>
              <p className="text-muted-foreground text-xs">State-approved CE provider with verified accreditation</p>
            </div>
            <div className="bg-muted rounded-lg p-5 text-center">
              <Clock className="w-8 h-8 mx-auto mb-3 text-primary" />
              <h4 className="font-bold text-lg mb-1">Flexible</h4>
              <p className="text-muted-foreground text-xs">Complete courses at your own pace, anytime, anywhere</p>
            </div>
          </div>

          <div className="bg-[#448bcd] rounded-lg p-6 text-center">
            <h3 className="text-xl font-bold text-white mb-3">Ready to Get Started?</h3>
            <p className="text-white/90 text-sm mb-4">Enroll in our continuing education courses today and stay ahead in your career.</p>
            <a href="mailto:ce@tpshousing.com" className="inline-block bg-white text-[#448bcd] font-semibold px-6 py-2 rounded-lg hover:bg-white/90 transition-colors text-sm">
              Contact Us to Enroll
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
